"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

/**
 * @param {{ offset: number, limit: number }} pagination
 * @param {Object} params
 *
 * @returns {Object}
 */
var joinPaginationMlkl = function joinPaginationMlkl(pagination) {
  return function (params) {
    return !pagination ? params : (0, _extends2.default)({}, params || {}, {
      pageSize: pagination.rowsPerPage,
      page: pagination.page
    });
  };
};

var _default = joinPaginationMlkl;
exports.default = _default;